var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.role === 1 ? _c("OverviewAdmin") : _c("Overview")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }